module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Applications_03-a8cdf17dd8ead9e537c65c12bdc6a3af.jpg";